module.exports = __webpack_public_path__ + "static/first-7fbc7de894b5e804900e3dd6902bd431.svg";